export function parseCep(cep) {
    return cep.replace(/\D/g, '')
}